import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import CreateUser from '../components/CreateUser.vue'
import Labelling from '../components/Labelling.vue'
import QuestionLabelling from '../components/QuestionLabelling.vue'
import GraphSelector from '../components/GraphSelector.vue'
import End from '../components/End.vue'
import Instruction from '../components/Instruction.vue'
// Prolific study (separate from original system)
import ProlificEntry from '../components/ProlificEntry.vue'
import Demographics from '../components/Demographics.vue'
import Training from '../components/Training.vue'
import TrainingFailed from '../components/TrainingFailed.vue'
import TrainingResult from '../components/TrainingResult.vue'
import ProlificFinish from '../components/ProlificFinish.vue'
import PostStudy from '../components/PostStudy.vue'
import ProlificMainStudy from '../components/ProlificMainStudy.vue'
import ProlificQuestionLabelling from '../components/prolific/ProlificQuestionLabelling.vue'
import Consent from '../components/prolific/Consent.vue'
import TrainingVideo from '../components/prolific/TrainingVideo.vue'
import Practice from '../components/prolific/Practice.vue'
import Screening from '../components/prolific/Screening.vue'
import MainStudyCover from '../components/prolific/MainStudyCover.vue'

Vue.use(VueRouter)

const routes = [
  // ===== Original labeling system (unchanged) =====
  { path: '/', name: 'Home', component: Home },
  { path: '/create_user', name: 'Create New User', component: CreateUser },
  { path: '/labelling/:userid/:username/:graphid', name: 'Labelling', component: Labelling },
  { path: '/question-labelling/:userid/:username/:graphid', name: 'QuestionLabelling', component: QuestionLabelling },
  { path: '/graph-selector/:userid/:username', name: 'GraphSelector', component: GraphSelector },
  { path: '/end/:userid', name: 'End', component: End },
  { path: '/instruction/', name: 'Instruction', component: Instruction },

  // ===== Prolific study system (separate entry + routes) =====
  { path: '/prolific/entry', name: 'ProlificEntry', component: ProlificEntry },
  { path: '/prolific/study/:sessionId/consent', name: 'ProlificConsent', component: Consent },
  { path: '/prolific/study/:sessionId/video', name: 'ProlificTrainingVideo', component: TrainingVideo },
  { path: '/prolific/study/:sessionId/practice', name: 'ProlificPractice', component: Practice },
  { path: '/prolific/study/:sessionId/screening', name: 'ProlificScreening', component: Screening },
  { path: '/prolific/study/:sessionId/main-intro', name: 'ProlificMainIntro', component: MainStudyCover },
  { path: '/prolific/study/:sessionId/demographics', name: 'ProlificDemographics', component: Demographics },
  { path: '/prolific/study/:sessionId/training', name: 'ProlificTraining', component: Training },
  { path: '/prolific/study/:sessionId/training-result', name: 'ProlificTrainingResult', component: TrainingResult },
  { path: '/prolific/study/:sessionId/training-failed', name: 'ProlificTrainingFailed', component: TrainingFailed },
  { path: '/prolific/study/:sessionId/main', name: 'ProlificMainStudy', component: ProlificMainStudy },
  { path: '/prolific/study/:sessionId/main/:graphId', name: 'ProlificMainStudyGraph', component: ProlificMainStudy },
  { path: '/prolific/study/:sessionId/label/:graphId', name: 'ProlificQuestionLabelling', component: ProlificQuestionLabelling },
  { path: '/prolific/study/:sessionId/post-study', name: 'ProlificPostStudy', component: PostStudy },
  { path: '/prolific/study/:sessionId/finish', name: 'ProlificFinish', component: ProlificFinish },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
